export default {
    project(state) {
        return (payload) => {
            return state.projects[payload[0].toLowerCase()][payload[1]];
        };
    },
    projects(state) {
        return (group) => {
            return state.projects[group];
        }
    },
    isValid(state) {
        return (property) => {
            return Object.prototype.hasOwnProperty.call(state.projects[property[0]], property[1]);
        }
    }
}